import React, { createContext, useState } from 'react';



export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
    const [reasonsOptions, setReasonsOptions] = useState([])
    const [resolutionsOptions, setResolutionsOptions] = useState([])
    const [resolutionsLoading, setResolutionsLoading] = useState(false)

  return (
    <NotificationContext.Provider value={{ 
      reasonsOptions, setReasonsOptions, resolutionsOptions, setResolutionsOptions, resolutionsLoading, setResolutionsLoading
    }}>
      {children}
    </NotificationContext.Provider>
  );
};